import loadable from '@loadable/component';
import personalizationLoaderQuery from './query.graphql';

const PersonalizationLoader = loadable(() =>
  import(/* webpackChunkName: "extra" */ './personalization')
);

PersonalizationLoader.graphQL = personalizationLoaderQuery;

export default PersonalizationLoader;
